module.exports = __webpack_public_path__ + "static/media/image-research.d0f20db0.png";